<template>
  <div class="dialer-container">
    <!-- 顶部用户信息栏 -->
    <div class="header">
      <div class="user-info">
        <span class="current-number">当前账号：{{ userNumber }}</span>
        <span class="status">状态：{{ onlineStatus }}</span>
      </div>
      <el-button type="text" class="logout-btn" @click="handleLogout">退出</el-button>
    </div>
    <div class="dialer-tabs">
      <div 
        class="tab" 
        :class="{ active: currentTab === 'callout' }"
        @click="currentTab = 'callout'">外呼</div>
      <div 
        class="tab"
        :class="{ active: currentTab === 'records' }"
        @click="currentTab = 'records'">话单</div>
      <!-- <div 
        class="tab"
        :class="{ active: currentTab === 'stats' }"
        @click="currentTab = 'stats'">统计</div> -->
    </div>
    <!-- 主要内容区域 -->
    <div class="main-content">
      <component :is="currentComponent" @call="handleCallButton" />
    </div>
  </div>
</template>

<script>
import UCSIPCC from '@/utils/ucpaas-ipcc.js'
import CallOut from '@/components/CallOut.vue'
import CallRecords from '@/components/CallRecords.vue'

export default {
  name: 'DialerView',
  components: {
    CallOut,
    CallRecords
  },
  data() {
    return {
      userNumber: '',
      showStatus: false,
      statusText: '',
      onlineStatus: '离线',
      timer: {
        timerId: null,
        count: 0
      },
      currentTab: 'callout'
    }
  },
  computed: {
    currentComponent() {
      switch (this.currentTab) {
        case 'callout':
          return 'CallOut'
        case 'records':
          return 'CallRecords'
        case 'stats':
          return 'CallOut' // 暂时返回 CallContent
        default:
          return 'CallOut'
      }
    }
  },
  mounted() {
    this.initializeIpcc()
  },
  methods: {
    initializeIpcc() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      this.userInfo = userInfo
      this.userNumber = userInfo.sipUserName

      const options = {
        authorizationUser: userInfo.sipUserName,
        password: userInfo.password,
        wsServers: userInfo.websocketAddres,
        on_event: this.handleLogEvent,
        on_inbound: this.handleIncomingCall
      }

      UCSIPCC.login(options)
    },
    handleCallButton() {
      // 
    },
    handleLogEvent(status_code) {
      switch (status_code) {
        case 0: // REG_SUCCESS
          // this.$message.success('注册成功')
          break
        case 1: // CONN_SUCCESS
          // this.$message.success('连接成功')
          this.onlineStatus = '在线'
          break
        case 2: // CONN_FAILED
          // this.$message.error('连接失败')
          this.onlineStatus = '离线'
          this.$root.$emit('network-offline')
          break
        case 3: // REG_FAILED
          // this.$message.error('注册失败')
          this.onlineStatus = '离线'
          this.$root.$emit('network-offline')
          break
        case 4: // REG_AUTH_FAILED
          // this.$message.error('鉴权失败')
          this.onlineStatus = '离线'
          this.$root.$emit('network-offline')
          break
        default:
          // this.$message.error('未知错误')
          break
      }
    },
    handleIncomingCall() {
      // 
    },
    handleLogout() {
      UCSIPCC.logout()
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      this.$router.push('/login')
    }
  },
  beforeDestroy() {
    if (this.timer.timerId) {
      clearInterval(this.timer.timerId)
    }
    UCSIPCC.logout()
  }
}
</script>

<style lang="less" scoped>
.dialer-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: white;
}

.header {
  height: 48px;
  background: #5579E7;
  padding: 0 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: 20px;
}

.current-number {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
}

.status {
  font-size: 14px;
  font-weight: 400;
  color: #fff;
}

.logout-btn {
  font-size: 14px;
  color: #fff;
}

.dialer-tabs {
  width: 800px;
  height: 48px;
  background: white;
  border-radius: 24px;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #5579E7;
}

.tab {
  flex: 1;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #5579E7;
  cursor: pointer;
  border-radius: 24px;
  transition: all 0.3s;

  &.active {
    background: #5579E7;
    color: #fff;
    font-weight: 500;
  }

  &:not(.active):hover {
    background: rgba(85, 121, 231, 0.1);
  }
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: row;
  padding: 0 20px 20px;
  background: white;
}

:deep(.el-table) {
  &::before {
    display: none;
  }

  .el-table__header-wrapper {
    border-radius: 0;
    overflow: hidden;
  }

  .el-table__body-wrapper {
    overflow-x: hidden;
    
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    
    &::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background: #E4E7ED;
    }
    
    &::-webkit-scrollbar-track {
      border-radius: 3px;
      background: #F5F7FA;
    }
  }
  .el-table__fixed-right::before, .el-table__fixed::before {
    display: none;
  }

  .el-table__row {
    &:hover > td {
      background-color: #F1F5FF !important;
    }
  }
}
</style>
